import { IActionCommonResponse, UPDATE_COMMON_RESPONSE } from '@redux/reducer/commonResponseReducer';
import { useDispatch } from '@redux/store';
import { UPDATE_ERROR } from '../common/actionType/actionType';
import { IActionUI } from '@redux/reducer/uiReducer';
import { Response } from '../libs/api/Response';

export function useCommonActionFromDALV2() {
  const dispatch = useDispatch();

  return (DAL_Function: any, ...params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      DAL_Function(...params)
        .then((res: any) => {
          dispatch({
            type: UPDATE_COMMON_RESPONSE,
            payload: res,
          } as IActionCommonResponse);

          resolve(res);
        })
        .catch((error: Response) => {
          if (error.status === 401 || error.status === 403) {
            dispatch({
              type: UPDATE_ERROR,
              errorStatus: error.status,
              errorResponse: error.data,
            } as IActionUI);
          }
          reject(error);
        });
    });
  };
}
